import DocumentsPage from "@/pages/DocumentsPage";

export default function PrepDocumentsPage() {
  return <DocumentsPage operationalOnly />;
}